// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Button,
//   Form,
//   Modal,
//   InputGroup,
//   Pagination,
//   Badge,
//   Spinner,
// } from "react-bootstrap";
// import api from "../../api";
// import Can from "../../components/Can";
// import { usePermissions } from "../../context/PermissionContext";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./TaskStatusManagementPage.css";

// const CATEGORY_VALUES = ["OPEN", "IN_PROGRESS", "WAITING", "COMPLETED", "APPROVAL", "CLOSED", "CANCELLED"];

// const initialForm = {
//   name: "",
//   code: "",
//   description: "",
//   category: "OPEN",
//   is_initial: false,
//   is_terminal: false,
//   is_closed_state: false,
//   color: "",
//   icon: "",
//   display_order: "",
// };

// export default function TaskStatusManagementPage() {
//   const { can } = usePermissions();

//   const [statuses, setStatuses] = useState([]);
//   const [total, setTotal] = useState(0);

//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [systemFilter, setSystemFilter] = useState("");
//   const [categoryFilter, setCategoryFilter] = useState("");

//   const [sortField, setSortField] = useState("display_order");
//   const [sortOrder, setSortOrder] = useState("asc");

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(20);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);

//   const [form, setForm] = useState(initialForm);
//   const [editId, setEditId] = useState(null);
//   const [editIsSystem, setEditIsSystem] = useState(false);
//   const [showModal, setShowModal] = useState(false);

//   const [deleteTarget, setDeleteTarget] = useState(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);

//   useEffect(() => {
//     fetchStatuses();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [search, statusFilter, systemFilter, categoryFilter, sortField, sortOrder, currentPage, pageSize]);

//   const fetchStatuses = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/task-statuses", {
//         params: {
//           search: search || undefined,
//           is_active: statusFilter === "" ? undefined : statusFilter,
//           is_system: systemFilter === "" ? undefined : systemFilter,
//           category: categoryFilter || undefined,
//           sortField,
//           sortOrder,
//           page: currentPage,
//           pageSize,
//         },
//       });
//       setStatuses(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       console.error("Fetch task statuses error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch task statuses");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const handleSort = (field) => {
//     if (sortField === field) {
//       setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
//     } else {
//       setSortField(field);
//       setSortOrder("asc");
//     }
//   };

//   const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

//   const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

//   const openAdd = () => {
//     setForm(initialForm);
//     setEditId(null);
//     setEditIsSystem(false);
//     setShowModal(true);
//   };

//   const openEdit = (status) => {
//     setForm({
//       name: status.name || "",
//       code: status.code || "",
//       description: status.description || "",
//       category: status.category || "OPEN",
//       is_initial: !!status.is_initial,
//       is_terminal: !!status.is_terminal,
//       is_closed_state: !!status.is_closed_state,
//       color: status.color || "",
//       icon: status.icon || "",
//       display_order: status.display_order ?? "",
//     });
//     setEditId(status.id);
//     setEditIsSystem(!!status.is_system);
//     setShowModal(true);
//   };

//   const closeModal = () => {
//     setShowModal(false);
//     setEditId(null);
//     setEditIsSystem(false);
//     setForm(initialForm);
//   };

//   const handleSave = async () => {
//     if (!form.name.trim()) {
//       toast.warning("Status name is required");
//       return;
//     }

//     const payload = {
//       name: form.name.trim(),
//       description: form.description.trim() || null,
//       category: form.category,
//       is_initial: form.is_initial,
//       is_terminal: form.is_terminal,
//       is_closed_state: form.is_closed_state,
//       color: form.color.trim() || null,
//       icon: form.icon.trim() || null,
//       display_order: form.display_order === "" ? 0 : Number(form.display_order),
//     };

//     if (!editId) {
//       payload.code = form.code.trim() || undefined;
//     }

//     try {
//       setSaving(true);
//       if (editId) {
//         await api.put(`/task-statuses/${editId}`, payload);
//         toast.success("Task status updated");
//       } else {
//         await api.post("/task-statuses", payload);
//         toast.success("Task status created");
//       }
//       closeModal();
//       fetchStatuses();
//     } catch (err) {
//       console.error("Save task status error:", err);
//       toast.error(err.response?.data?.message || "Failed to save task status");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggleStatus = async (status) => {
//     try {
//       await api.patch(`/task-statuses/${status.id}/status`, { is_active: !status.is_active });
//       toast.success(status.is_active ? "Status deactivated" : "Status activated");
//       fetchStatuses();
//     } catch (err) {
//       console.error("Toggle status error:", err);
//       toast.error(err.response?.data?.message || "Failed to update status");
//     }
//   };

//   const openDeleteModal = (status) => {
//     setDeleteTarget(status);
//     setShowDeleteModal(true);
//   };

//   const closeDeleteModal = () => {
//     setDeleteTarget(null);
//     setShowDeleteModal(false);
//   };

//   const confirmDelete = async () => {
//     if (!deleteTarget) return;
//     try {
//       await api.delete(`/task-statuses/${deleteTarget.id}`);
//       toast.success("Task status deleted");
//       closeDeleteModal();
//       fetchStatuses();
//     } catch (err) {
//       console.error("Delete task status error:", err);
//       const data = err.response?.data;
//       if (data?.code === "STATUS_IN_USE") {
//         const d = data.details?.dependents;
//         toast.error(`Cannot delete: in use (tasks: ${d?.tasks ?? 0}, history: ${d?.history ?? 0}, workflows: ${d?.workflowStatuses ?? 0}). Deactivate instead.`);
//       } else if (data?.code === "TASK_STATUS_SYSTEM_PROTECTED") {
//         toast.error("This status is protected and cannot be deleted.");
//       } else {
//         toast.error(data?.message || "Failed to delete task status");
//       }
//       closeDeleteModal();
//     }
//   };

//   return (
//     <div className="unit-page taskstatus-mgmt-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Configuration</div>
//           <h2>Task Status Management</h2>
//           <p>Configure the statuses tasks can be in. Statuses are never hardcoded — workflows reference them by code.</p>
//         </div>

//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchStatuses}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>

//           <Can moduleKey="task_statuses" actionKey="create">
//             <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
//               <i className="fa-solid fa-plus" aria-hidden="true"></i>
//               Add Status
//             </Button>
//           </Can>
//         </div>
//       </div>

//       <div className="unit-stats-row">
//         <div className="unit-stat-card">
//           <div className="taskstatus-stat-icon taskstatus-stat-icon-primary">
//             <i className="fa-solid fa-flag" aria-hidden="true"></i>
//           </div>
//           <div className="taskstatus-stat-text">
//             <span>Total Statuses</span>
//             <strong>{total}</strong>
//           </div>
//         </div>
//         <div className="unit-stat-card">
//           <div className="taskstatus-stat-icon taskstatus-stat-icon-success">
//             <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
//           </div>
//           <div className="taskstatus-stat-text">
//             <span>Current Page</span>
//             <strong>{currentPage}</strong>
//           </div>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div>
//             <h5>
//               <i className="fa-solid fa-flag taskstatus-list-icon" aria-hidden="true"></i>
//               Status List
//             </h5>
//             <p>Search, filter, add, update, activate/deactivate or delete task statuses.</p>
//           </div>

//           <div className="unit-toolbar-actions" style={{ flexWrap: "wrap", gap: 8 }}>
//             <InputGroup className="unit-search" style={{ maxWidth: 240 }}>
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search name or code..."
//                 aria-label="Search task statuses by name or code"
//                 value={search}
//                 onChange={(e) => {
//                   setCurrentPage(1);
//                   setSearch(e.target.value);
//                 }}
//               />
//             </InputGroup>

//             <Form.Select
//               style={{ maxWidth: 150 }}
//               value={categoryFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setCategoryFilter(e.target.value);
//               }}
//             >
//               <option value="">All Categories</option>
//               {CATEGORY_VALUES.map((c) => (
//                 <option key={c} value={c}>{c}</option>
//               ))}
//             </Form.Select>

//             <Form.Select
//               style={{ maxWidth: 150 }}
//               value={statusFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setStatusFilter(e.target.value);
//               }}
//             >
//               <option value="">All Statuses</option>
//               <option value="1">Active</option>
//               <option value="0">Inactive</option>
//             </Form.Select>

//             <Form.Select
//               style={{ maxWidth: 170 }}
//               value={systemFilter}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setSystemFilter(e.target.value);
//               }}
//             >
//               <option value="">System: Any</option>
//               <option value="1">System only</option>
//               <option value="0">Non-system only</option>
//             </Form.Select>

//             <Form.Select
//               className="unit-page-size"
//               style={{ maxWidth: 120 }}
//               value={pageSize}
//               onChange={(e) => {
//                 setCurrentPage(1);
//                 setPageSize(Number(e.target.value));
//               }}
//             >
//               <option value={10}>10 rows</option>
//               <option value={20}>20 rows</option>
//               <option value={50}>50 rows</option>
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader">
//               <Spinner animation="border" />
//               <p>Loading task statuses...</p>
//             </div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
//                   <th className="sortable" onClick={() => handleSort("code")}>Code {sortIcon("code")}</th>
//                   <th className="sortable" onClick={() => handleSort("category")}>Category {sortIcon("category")}</th>
//                   <th>Flags</th>
//                   <th>System</th>
//                   <th className="sortable" onClick={() => handleSort("is_active")}>Status {sortIcon("is_active")}</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {statuses.length > 0 ? (
//                   statuses.map((status) => (
//                     <tr key={status.id}>
//                       <td>
//                         <strong>
//                           {status.color && (
//                             <span
//                               className="taskstatus-color-dot"
//                               style={{
//                                 display: "inline-block",
//                                 width: 10,
//                                 height: 10,
//                                 borderRadius: "50%",
//                                 backgroundColor: status.color,
//                                 marginRight: 6,
//                               }}
//                             />
//                           )}
//                           {status.name}
//                         </strong>
//                       </td>
//                       <td>
//                         {status.code}
//                         {status.is_system && (
//                           <>
//                             <br />
//                             <small className="text-muted">Code is protected — cannot be changed</small>
//                           </>
//                         )}
//                       </td>
//                       <td><Badge bg="light" text="dark">{status.category}</Badge></td>
//                       <td>
//                         {status.is_initial && <Badge bg="info" className="me-1 mb-1">Initial</Badge>}
//                         {status.is_terminal && <Badge bg="secondary" className="me-1 mb-1">Terminal</Badge>}
//                         {status.is_closed_state && <Badge bg="dark" className="me-1 mb-1">Closed state</Badge>}
//                       </td>
//                       <td>
//                         {status.is_system ? <Badge bg="warning" text="dark">System</Badge> : "—"}
//                       </td>
//                       <td>
//                         <Badge
//                           bg={status.is_active ? "success" : "secondary"}
//                           className="taskstatus-status-pill"
//                         >
//                           {status.is_active ? "Active" : "Inactive"}
//                         </Badge>
//                       </td>
//                       <td>
//                         <div className="unit-actions">
//                           <Can moduleKey="task_statuses" actionKey="edit">
//                             <Button
//                               className="unit-icon-btn unit-edit"
//                               title="Edit"
//                               aria-label={`Edit ${status.name || "status"}`}
//                               onClick={() => openEdit(status)}
//                             >
//                               <i className="fa-solid fa-pen" aria-hidden="true"></i>
//                             </Button>
//                           </Can>

//                           {(can("task_statuses", "activate") || can("task_statuses", "deactivate")) && (
//                             <Button
//                               className="unit-icon-btn taskstatus-toggle"
//                               title={status.is_active ? "Deactivate" : "Activate"}
//                               aria-label={status.is_active ? `Deactivate ${status.name || "status"}` : `Activate ${status.name || "status"}`}
//                               onClick={() => toggleStatus(status)}
//                               disabled={status.is_system && status.is_active}
//                             >
//                               <i className={`fa-solid ${status.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
//                             </Button>
//                           )}

//                           <Can moduleKey="task_statuses" actionKey="delete">
//                             <Button
//                               className="unit-icon-btn unit-delete"
//                               title={status.is_system ? "Protected — cannot be deleted" : "Delete"}
//                               aria-label={status.is_system ? `${status.name || "Status"} is protected and cannot be deleted` : `Delete ${status.name || "status"}`}
//                               onClick={() => openDeleteModal(status)}
//                               disabled={status.is_system}
//                             >
//                               <i className="fa-solid fa-trash" aria-hidden="true"></i>
//                             </Button>
//                           </Can>
//                         </div>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="7">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-flag" aria-hidden="true"></i>
//                         </div>
//                         <h5>No task statuses found</h5>
//                         <p>Try another search or add a new status.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">
//             Showing <strong>{statuses.length}</strong> of <strong>{total}</strong> statuses
//           </div>

//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
//                   {i + 1}
//                 </Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal show={showModal} onHide={closeModal} centered className="unit-modal" size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>{editId ? "Edit Task Status" : "Add New Task Status"}</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="row g-3">
//             <div className="col-md-6">
//               <Form.Label>Name</Form.Label>
//               <Form.Control
//                 placeholder="e.g. In Testing"
//                 value={form.name}
//                 onChange={(e) => handleChange("name", e.target.value)}
//               />
//             </div>

//             <div className="col-md-6">
//               <Form.Label>Code {editId ? "(immutable)" : "(optional — derived from name if blank)"}</Form.Label>
//               <Form.Control
//                 placeholder="e.g. TESTING"
//                 value={form.code}
//                 disabled={!!editId}
//                 onChange={(e) => handleChange("code", e.target.value)}
//               />
//               {editIsSystem && <Form.Text className="text-danger">This is a protected system status.</Form.Text>}
//             </div>

//             <div className="col-md-12">
//               <Form.Label>Description</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 value={form.description}
//                 onChange={(e) => handleChange("description", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Category</Form.Label>
//               <Form.Select value={form.category} onChange={(e) => handleChange("category", e.target.value)}>
//                 {CATEGORY_VALUES.map((c) => <option key={c} value={c}>{c}</option>)}
//               </Form.Select>
//               <Form.Text muted>Classification/reporting only — never used for transition logic.</Form.Text>
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Color (optional)</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="#6c757d"
//                 value={form.color}
//                 onChange={(e) => handleChange("color", e.target.value)}
//               />
//             </div>

//             <div className="col-md-4">
//               <Form.Label>Display Order</Form.Label>
//               <Form.Control
//                 type="number"
//                 value={form.display_order}
//                 onChange={(e) => handleChange("display_order", e.target.value)}
//               />
//             </div>

//             <div className="col-md-12">
//               <Form.Label className="d-block">Descriptive Flags</Form.Label>
//               <div className="d-flex flex-wrap gap-3">
//                 <Form.Check
//                   type="checkbox"
//                   label="Typically an initial status"
//                   checked={form.is_initial}
//                   onChange={(e) => handleChange("is_initial", e.target.checked)}
//                 />
//                 <Form.Check
//                   type="checkbox"
//                   label="Typically a terminal status"
//                   checked={form.is_terminal}
//                   onChange={(e) => handleChange("is_terminal", e.target.checked)}
//                 />
//                 <Form.Check
//                   type="checkbox"
//                   label="Counts as closed (escalation/reporting)"
//                   checked={form.is_closed_state}
//                   onChange={(e) => handleChange("is_closed_state", e.target.checked)}
//                 />
//               </div>
//               <Form.Text muted>
//                 These are descriptive defaults only. The authoritative initial/terminal status per
//                 workflow is set in Workflow Management.
//               </Form.Text>
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-primary" onClick={handleSave} disabled={saving}>
//             {saving ? "Saving..." : editId ? "Update Status" : "Create Status"}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <Modal show={showDeleteModal} onHide={closeDeleteModal} centered className="unit-modal">
//         <Modal.Header closeButton>
//           <Modal.Title>Delete Task Status</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p className="unit-delete-text">
//             Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
//             If tasks, history, or workflows reference it, deletion will be blocked — deactivate it instead.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>Cancel</Button>
//           <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>Delete</Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }





import React, { useEffect, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import {
  Table,
  Button,
  Form,
  Modal,
  InputGroup,
  Pagination,
  Badge,
  Spinner,
} from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import { usePermissions } from "../../context/PermissionContext";
import { toast } from "react-toastify";
import "./TaskStatusManagementPage.css";

const CATEGORY_VALUES = ["OPEN", "IN_PROGRESS", "WAITING", "COMPLETED", "APPROVAL", "CLOSED", "CANCELLED"];

const initialForm = {
  name: "",
  code: "",
  description: "",
  category: "OPEN",
  is_initial: false,
  is_terminal: false,
  is_closed_state: false,
  color: "",
  icon: "",
  display_order: "",
};

export default function TaskStatusManagementPage() {
  const { can } = usePermissions();

  const [statuses, setStatuses] = useState([]);
  const [total, setTotal] = useState(0);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [systemFilter, setSystemFilter] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");

  const [sortField, setSortField] = useState("display_order");
  const [sortOrder, setSortOrder] = useState("asc");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState(initialForm);
  const [editId, setEditId] = useState(null);
  const [editIsSystem, setEditIsSystem] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    fetchStatuses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, statusFilter, systemFilter, categoryFilter, sortField, sortOrder, currentPage, pageSize]);

  const fetchStatuses = async () => {
    try {
      setLoading(true);
      const res = await api.get("/task-statuses", {
        params: {
          search: search || undefined,
          is_active: statusFilter === "" ? undefined : statusFilter,
          is_system: systemFilter === "" ? undefined : systemFilter,
          category: categoryFilter || undefined,
          sortField,
          sortOrder,
          page: currentPage,
          pageSize,
        },
      });
      setStatuses(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      console.error("Fetch task statuses error:", err);
      toast.error(err.response?.data?.message || "Failed to fetch task statuses");
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const sortIcon = (field) => (sortField !== field ? "↕" : sortOrder === "asc" ? "↑" : "↓");

  const handleChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const openAdd = () => {
    setForm(initialForm);
    setEditId(null);
    setEditIsSystem(false);
    setShowModal(true);
  };

  const openEdit = (status) => {
    setForm({
      name: status.name || "",
      code: status.code || "",
      description: status.description || "",
      category: status.category || "OPEN",
      is_initial: !!status.is_initial,
      is_terminal: !!status.is_terminal,
      is_closed_state: !!status.is_closed_state,
      color: status.color || "",
      icon: status.icon || "",
      display_order: status.display_order ?? "",
    });
    setEditId(status.id);
    setEditIsSystem(!!status.is_system);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditId(null);
    setEditIsSystem(false);
    setForm(initialForm);
  };

  const handleSave = async () => {
    if (!form.name.trim()) {
      toast.warning("Status name is required");
      return;
    }

    const payload = {
      name: form.name.trim(),
      description: form.description.trim() || null,
      category: form.category,
      is_initial: form.is_initial,
      is_terminal: form.is_terminal,
      is_closed_state: form.is_closed_state,
      color: form.color.trim() || null,
      icon: form.icon.trim() || null,
      display_order: form.display_order === "" ? 0 : Number(form.display_order),
    };

    if (!editId) {
      payload.code = form.code.trim() || undefined;
    }

    try {
      setSaving(true);
      if (editId) {
        await api.put(`/task-statuses/${editId}`, payload);
        toast.success("Task status updated");
      } else {
        await api.post("/task-statuses", payload);
        toast.success("Task status created");
      }
      closeModal();
      fetchStatuses();
    } catch (err) {
      console.error("Save task status error:", err);
      toast.error(err.response?.data?.message || "Failed to save task status");
    } finally {
      setSaving(false);
    }
  };

  const toggleStatus = async (status) => {
    try {
      await api.patch(`/task-statuses/${status.id}/status`, { is_active: !status.is_active });
      toast.success(status.is_active ? "Status deactivated" : "Status activated");
      fetchStatuses();
    } catch (err) {
      console.error("Toggle status error:", err);
      toast.error(err.response?.data?.message || "Failed to update status");
    }
  };

  const openDeleteModal = (status) => {
    setDeleteTarget(status);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteTarget(null);
    setShowDeleteModal(false);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await api.delete(`/task-statuses/${deleteTarget.id}`);
      toast.success("Task status deleted");
      closeDeleteModal();
      fetchStatuses();
    } catch (err) {
      console.error("Delete task status error:", err);
      const data = err.response?.data;
      if (data?.code === "STATUS_IN_USE") {
        const d = data.details?.dependents;
        toast.error(`Cannot delete: in use (tasks: ${d?.tasks ?? 0}, history: ${d?.history ?? 0}, workflows: ${d?.workflowStatuses ?? 0}). Deactivate instead.`);
      } else if (data?.code === "TASK_STATUS_SYSTEM_PROTECTED") {
        toast.error("This status is protected and cannot be deleted.");
      } else {
        toast.error(data?.message || "Failed to delete task status");
      }
      closeDeleteModal();
    }
  };

  return (
    <div className="unit-page taskstatus-mgmt-theme">

      <div className="taskstatus-heading-box">
        <div className="taskstatus-heading-content">
          <div className="taskstatus-heading-icon">
            <i className="fa-solid fa-flag" aria-hidden="true"></i>
          </div>

          <div>
            <div className="unit-page-label">Configuration</div>
            <h2>Task Status Management</h2>
            <p>Configure the statuses tasks can be in. Statuses are never hardcoded — workflows reference them by code.</p>
          </div>
        </div>

        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchStatuses}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>

          <Can moduleKey="task_statuses" actionKey="create">
            <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
              <i className="fa-solid fa-plus" aria-hidden="true"></i>
              Add Status
            </Button>
          </Can>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card taskstatus-stat-blue">
          <div className="taskstatus-stat-content">
            <div className="taskstatus-stat-text">
              <span>Total Statuses</span>
              <strong>{total}</strong>
            </div>

            <div className="taskstatus-stat-icon">
              <i className="fa-solid fa-flag" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card taskstatus-stat-purple">
          <div className="taskstatus-stat-content">
            <div className="taskstatus-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="taskstatus-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card taskstatus-stat-green">
          <div className="taskstatus-stat-content">
            <div className="taskstatus-stat-text">
              <span>Rows Per Page</span>
              <strong>{pageSize}</strong>
            </div>

            <div className="taskstatus-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar taskstatus-toolbar">
          <div className="taskstatus-section-title">
            <div className="taskstatus-section-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>

            <div className="taskstatus-section-copy">
              <h5>Status List</h5>
              <p>Search, filter, add, update, activate/deactivate or delete task statuses.</p>
            </div>
          </div>

          <div className="unit-toolbar-actions taskstatus-filters-row">
            <InputGroup className="unit-search taskstatus-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search name or code..."
                aria-label="Search task statuses by name or code"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="unit-clear-btn"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>

            <div className="taskstatus-select-wrap">
              <i className="fa-solid fa-layer-group taskstatus-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="taskstatus-filter-select"
                value={categoryFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setCategoryFilter(e.target.value);
              }}
            >
              <option value="">All Categories</option>
              {CATEGORY_VALUES.map((c) => (
                <option key={c} value={c}>{c}</option>
                ))}
              </Form.Select>
            </div>

            <div className="taskstatus-select-wrap">
              <i className="fa-solid fa-circle-check taskstatus-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="taskstatus-filter-select"
                value={statusFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setStatusFilter(e.target.value);
              }}
            >
              <option value="">All Statuses</option>
              <option value="1">Active</option>
                <option value="0">Inactive</option>
              </Form.Select>
            </div>

            <div className="taskstatus-select-wrap">
              <i className="fa-solid fa-shield-halved taskstatus-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="taskstatus-filter-select"
                value={systemFilter}
              onChange={(e) => {
                setCurrentPage(1);
                setSystemFilter(e.target.value);
              }}
            >
              <option value="">System: Any</option>
              <option value="1">System only</option>
                <option value="0">Non-system only</option>
              </Form.Select>
            </div>

            <Form.Select
              className="unit-page-size"
              value={pageSize}
              onChange={(e) => {
                setCurrentPage(1);
                setPageSize(Number(e.target.value));
              }}
            >
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
            </Form.Select>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader">
              <Spinner animation="border" />
              <p>Loading task statuses...</p>
            </div>
          ) : (
            <Table responsive className="unit-table">
              <thead>
                <tr>
                  <th className="sortable" onClick={() => handleSort("name")}>Name {sortIcon("name")}</th>
                  <th className="sortable" onClick={() => handleSort("code")}>Code {sortIcon("code")}</th>
                  <th className="sortable" onClick={() => handleSort("category")}>Category {sortIcon("category")}</th>
                  <th>Flags</th>
                  <th>System</th>
                  <th className="sortable" onClick={() => handleSort("is_active")}>Status {sortIcon("is_active")}</th>
                  <th className="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                {statuses.length > 0 ? (
                  statuses.map((status) => (
                    <tr key={status.id}>
                      <td>
                        <div className="taskstatus-name-box">
                          <div
                            className="taskstatus-color-avatar"
                            style={
                              status.color
                                ? { backgroundColor: status.color }
                                : undefined
                            }
                          >
                            <i className="fa-solid fa-flag" aria-hidden="true"></i>
                          </div>

                          <div className="taskstatus-name-copy">
                            <strong title={status.name}>{status.name}</strong>
                            <small>Status ID: {status.id}</small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="taskstatus-code-wrap">
                          <span className="taskstatus-code-chip">
                            <i className="fa-solid fa-code" aria-hidden="true"></i>
                            {status.code || "—"}
                          </span>

                          {status.is_system && (
                            <small className="taskstatus-protected-note">
                              <i className="fa-solid fa-lock" aria-hidden="true"></i>
                              Protected code
                            </small>
                          )}
                        </div>
                      </td>
                      <td>
                        <span
                          className={`taskstatus-category-chip taskstatus-category-${String(
                            status.category || ""
                          ).toLowerCase()}`}
                        >
                          <i className="fa-solid fa-layer-group" aria-hidden="true"></i>
                          {status.category}
                        </span>
                      </td>
                      <td>
                        <div className="taskstatus-flags-wrap">
                          {status.is_initial && (
                            <span className="taskstatus-flag-chip taskstatus-flag-initial">
                              <i className="fa-solid fa-play" aria-hidden="true"></i>
                              Initial
                            </span>
                          )}
                          {status.is_terminal && (
                            <span className="taskstatus-flag-chip taskstatus-flag-terminal">
                              <i className="fa-solid fa-stop" aria-hidden="true"></i>
                              Terminal
                            </span>
                          )}
                          {status.is_closed_state && (
                            <span className="taskstatus-flag-chip taskstatus-flag-closed">
                              <i className="fa-solid fa-lock" aria-hidden="true"></i>
                              Closed
                            </span>
                          )}
                          {!status.is_initial &&
                            !status.is_terminal &&
                            !status.is_closed_state && (
                              <span className="taskstatus-muted">No flags</span>
                            )}
                        </div>
                      </td>
                      <td>
                        {status.is_system ? (
                          <Badge className="unit-status taskstatus-system-badge">
                            <i className="fa-solid fa-shield-halved me-1" aria-hidden="true"></i>
                            System
                          </Badge>
                        ) : (
                          <span className="taskstatus-custom-chip">
                            <i className="fa-solid fa-pen-ruler" aria-hidden="true"></i>
                            Custom
                          </span>
                        )}
                      </td>
                      <td>
                        <Badge
                          className={`taskstatus-status-pill ${
                            status.is_active
                              ? "taskstatus-status-active"
                              : "taskstatus-status-inactive"
                          }`}
                        >
                          <i
                            className={
                              status.is_active
                                ? "fa-solid fa-circle-check me-1"
                                : "fa-solid fa-circle-pause me-1"
                            }
                            aria-hidden="true"
                          ></i>
                          {status.is_active ? "Active" : "Inactive"}
                        </Badge>
                      </td>
                      <td>
                        <div className="unit-actions">
                          <Can moduleKey="task_statuses" actionKey="edit">
                            <Button
                              className="unit-icon-btn unit-edit"
                              title="Edit"
                              aria-label={`Edit ${status.name || "status"}`}
                              onClick={() => openEdit(status)}
                            >
                              <i className="fa-solid fa-pen" aria-hidden="true"></i>
                            </Button>
                          </Can>

                          {(can("task_statuses", "activate") || can("task_statuses", "deactivate")) && (
                            <Button
                              className={`unit-icon-btn taskstatus-toggle ${
                                status.is_active
                                  ? "taskstatus-toggle-off"
                                  : "taskstatus-toggle-on"
                              }`}
                              title={status.is_active ? "Deactivate" : "Activate"}
                              aria-label={status.is_active ? `Deactivate ${status.name || "status"}` : `Activate ${status.name || "status"}`}
                              onClick={() => toggleStatus(status)}
                              disabled={status.is_system && status.is_active}
                            >
                              <i className={`fa-solid ${status.is_active ? "fa-pause" : "fa-play"}`} aria-hidden="true"></i>
                            </Button>
                          )}

                          <Can moduleKey="task_statuses" actionKey="delete">
                            <Button
                              className="unit-icon-btn unit-delete"
                              title={status.is_system ? "Protected — cannot be deleted" : "Delete"}
                              aria-label={status.is_system ? `${status.name || "Status"} is protected and cannot be deleted` : `Delete ${status.name || "status"}`}
                              onClick={() => openDeleteModal(status)}
                              disabled={status.is_system}
                            >
                              <i className="fa-solid fa-trash" aria-hidden="true"></i>
                            </Button>
                          </Can>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-flag" aria-hidden="true"></i>
                        </div>
                        <h5>No task statuses found</h5>
                        <p>Try another search or add a new status.</p>

                        <Can moduleKey="task_statuses" actionKey="create">
                          <Button className="unit-btn unit-btn-primary" onClick={openAdd}>
                            <i className="fa-solid fa-plus" aria-hidden="true"></i>
                            Add Status
                          </Button>
                        </Can>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">
            Showing <strong>{statuses.length}</strong> of <strong>{total}</strong> statuses
          </div>

          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                  {i + 1}
                </Pagination.Item>
              )), currentPage)}
              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={showModal}
        onHide={closeModal}
        centered
        className="unit-modal"
        size="lg"
        dialogClassName="taskstatus-admin-modal taskstatus-admin-modal-lg"
        backdropClassName="taskstatus-admin-backdrop"
      >
        <Modal.Header closeButton>
          <div className="taskstatus-modal-heading">
            <div className="taskstatus-modal-icon">
              <i
                className={
                  editId
                    ? "fa-solid fa-pen-to-square"
                    : "fa-solid fa-flag"
                }
                aria-hidden="true"
              ></i>
            </div>

            <div>
              <small>Task Status Setup</small>
              <Modal.Title>{editId ? "Edit Task Status" : "Add New Task Status"}</Modal.Title>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row g-3">
            <div className="col-md-6">
              <Form.Label>Name</Form.Label>
              <div className="taskstatus-modal-field">
                <i className="fa-solid fa-flag" aria-hidden="true"></i>
                <Form.Control
                  placeholder="e.g. In Testing"
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-6">
              <Form.Label>Code {editId ? "(immutable)" : "(optional — derived from name if blank)"}</Form.Label>
              <div className="taskstatus-modal-field">
                <i className="fa-solid fa-code" aria-hidden="true"></i>
                <Form.Control
                  placeholder="e.g. TESTING"
                  value={form.code}
                  disabled={!!editId}
                  onChange={(e) => handleChange("code", e.target.value)}
                />
              </div>
              {editIsSystem && (
                <Form.Text className="taskstatus-system-warning">
                  <i className="fa-solid fa-shield-halved" aria-hidden="true"></i>
                  This is a protected system status.
                </Form.Text>
              )}
            </div>

            <div className="col-md-12">
              <Form.Label>Description</Form.Label>
              <div className="taskstatus-modal-field taskstatus-modal-field-textarea">
                <i className="fa-regular fa-note-sticky" aria-hidden="true"></i>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={form.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-4">
              <Form.Label>Category</Form.Label>
              <Form.Select value={form.category} onChange={(e) => handleChange("category", e.target.value)}>
                {CATEGORY_VALUES.map((c) => <option key={c} value={c}>{c}</option>)}
              </Form.Select>
              <Form.Text muted>Classification/reporting only — never used for transition logic.</Form.Text>
            </div>

            <div className="col-md-4">
              <Form.Label>Color (optional)</Form.Label>
              <div className="taskstatus-color-field">
                <span
                  className="taskstatus-color-preview"
                  style={
                    form.color
                      ? { backgroundColor: form.color }
                      : undefined
                  }
                  aria-hidden="true"
                ></span>
                <Form.Control
                  type="text"
                  placeholder="#6c757d"
                  value={form.color}
                  onChange={(e) => handleChange("color", e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-4">
              <Form.Label>Display Order</Form.Label>
              <Form.Control
                type="number"
                value={form.display_order}
                onChange={(e) => handleChange("display_order", e.target.value)}
              />
            </div>

            <div className="col-md-12">
              <div className="taskstatus-flags-heading">
                <div>
                  <Form.Label className="d-block">Descriptive Flags</Form.Label>
                  <small>These labels help reporting and workflow setup.</small>
                </div>
              </div>

              <div className="taskstatus-config-grid">
                <Form.Check
                  className="taskstatus-config-check"
                  type="checkbox"
                  label="Typically an initial status"
                  checked={form.is_initial}
                  onChange={(e) => handleChange("is_initial", e.target.checked)}
                />
                <Form.Check
                  className="taskstatus-config-check"
                  type="checkbox"
                  label="Typically a terminal status"
                  checked={form.is_terminal}
                  onChange={(e) => handleChange("is_terminal", e.target.checked)}
                />
                <Form.Check
                  className="taskstatus-config-check"
                  type="checkbox"
                  label="Counts as closed (escalation/reporting)"
                  checked={form.is_closed_state}
                  onChange={(e) => handleChange("is_closed_state", e.target.checked)}
                />
              </div>
              <Form.Text muted>
                These are descriptive defaults only. The authoritative initial/terminal status per
                workflow is set in Workflow Management.
              </Form.Text>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button
            className="unit-btn unit-btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <Spinner animation="border" size="sm" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                {editId ? "Update Status" : "Create Status"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={closeDeleteModal}
        centered
        className="unit-modal"
        dialogClassName="taskstatus-admin-modal taskstatus-admin-modal-sm taskstatus-admin-modal-danger"
        backdropClassName="taskstatus-admin-backdrop"
      >
        <Modal.Header closeButton>
          <div className="taskstatus-modal-heading">
            <div className="taskstatus-modal-icon taskstatus-modal-icon-danger">
              <i className="fa-solid fa-trash" aria-hidden="true"></i>
            </div>

            <div>
              <small>Delete Action</small>
              <Modal.Title>Delete Task Status</Modal.Title>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="taskstatus-modal-danger-visual" aria-hidden="true">
            <i className="fa-solid fa-flag"></i>
          </div>

          <p className="unit-delete-text text-center">
            Are you sure you want to delete "{deleteTarget?.name}"? This action cannot be undone.
            If tasks, history, or workflows reference it, deletion will be blocked — deactivate it instead.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDeleteModal}>
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>

          <Button className="unit-btn unit-btn-danger" onClick={confirmDelete}>
            <i className="fa-solid fa-trash" aria-hidden="true"></i>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
